import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section id="pricing" className="py-16 px-4 bg-navy-800 relative" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        {/* La Inversión */}
        <FadeIn data-id="element-130">
          <h2 className="text-sm tracking-[0.2em] text-gold-500 font-bold mb-12 text-center uppercase font-body" data-id="element-131">
            La Inversión
          </h2>

          <div className="space-y-6 text-lg text-cream-200 mb-16" data-id="element-132">
            <p className="text-center italic mb-8" data-id="element-133">
              Piensa en esto un momento.
            </p>

            <div className="bg-navy-900 p-8 rounded-sm border border-navy-700 space-y-4" data-id="element-134">
              <p className="flex justify-between items-center border-b border-navy-700 pb-4" data-id="element-135">
                <span data-id="element-136">Un rollo de cinta Kinesiotaping cuesta</span>
                <span className="font-mono text-cream-100" data-id="element-137">entre $8 y $15</span>
              </p>
              <p className="flex justify-between items-center border-b border-navy-700 pb-4" data-id="element-138">
                <span data-id="element-139">Una aplicación profesional vale</span>
                <span className="font-mono text-cream-100" data-id="element-140">
                  entre $15 y $60
                </span>
              </p>
              <p className="flex justify-between items-center pb-2" data-id="element-141">
                <span data-id="element-142">Un curso presencial cuesta</span>
                <span className="font-mono text-cream-100" data-id="element-143">
                  entre $200 y $800
                </span>
              </p>
            </div>

            <div className="text-center mt-12 space-y-4" data-id="element-144">
              <p className="text-2xl font-heading text-gold-400 font-bold" data-id="element-145">
                Kinesiotaping Clínico Pro te da el sistema completo por una
                fracción de eso.
              </p>
              <p data-id="element-146">
                Una sola aplicación adicional por semana cubre la inversión en
                el primer mes.
              </p>
              <p className="text-xl text-cream-100" data-id="element-147">
                Y el conocimiento es tuyo para siempre.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Card */}
        <FadeIn delay={0.15} data-id="element-148">
          <div className="relative mb-12" data-id="element-149">
            {/* Glow effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-gold-500/20 via-gold-400/30 to-gold-500/20 rounded-sm blur-lg" data-id="element-150"></div>

            <div className="relative bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 border-2 border-gold-500/60 rounded-sm p-8 md:p-12 text-center overflow-hidden" data-id="element-151">
              {/* Corner decorations */}
              <div className="absolute top-0 left-0 w-24 h-24 bg-gold-500/10 rounded-br-full" data-id="element-152"></div>
              <div className="absolute bottom-0 right-0 w-24 h-24 bg-gold-500/10 rounded-tl-full" data-id="element-153"></div>

              {/* Discount badge */}
              <motion.div initial={{
              rotate: -3,
              scale: 0.9
            }} animate={{
              rotate: -3,
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 200,
              delay: 0.3
            }} className="absolute top-4 right-4 md:top-6 md:right-6 bg-red-500 text-white font-bold text-sm md:text-base py-2 px-4 rounded-sm shadow-lg transform" data-id="element-154">
                -60% OFF
              </motion.div>

              {/* "Solo por hoy" badge */}
              <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-400/40 text-red-300 text-sm font-bold tracking-wider uppercase py-2 px-5 rounded-full mb-8" data-id="element-155">
                <Zap className="w-4 h-4" data-id="element-156" />
                Solo por hoy
              </div>

              {/* Original price */}
              <div className="mb-2" data-id="element-157">
                <span className="text-cream-400/60 text-xl line-through decoration-red-400/70 decoration-2" data-id="element-158">
                  $15.99 USD
                </span>
              </div>

              {/* Discount price */}
              <div className="mb-2" data-id="element-159">
                <span className="text-6xl md:text-7xl font-heading font-bold text-cream-100" data-id="element-160">
                  $6
                </span>
                <span className="text-4xl md:text-5xl font-heading font-bold text-cream-100" data-id="element-161">
                  .39
                </span>
                <span className="text-xl text-gold-400 font-medium ml-2" data-id="element-162">
                  USD
                </span>
              </div>

              <p className="text-cream-300/80 text-base mb-8" data-id="element-163">
                Acceso inmediato y de por vida al manual completo
              </p>

              <CTAButton text="OBTENER MI MANUAL AHORA" isCheckout className="w-full md:w-auto text-xl py-5 px-10" data-id="element-164" />

              <p className="text-cream-400/50 text-xs mt-6" data-id="element-165">
                Pago único · Sin suscripciones · Descarga instantánea
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Garantía */}
        <FadeIn delay={0.2} data-id="element-166">
          <div className="bg-gradient-to-br from-navy-900 to-navy-800 border border-gold-500/50 p-8 md:p-12 rounded-sm text-center relative overflow-hidden my-12 shadow-[0_0_40px_rgba(201,168,76,0.1)]" data-id="element-167">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/10 rounded-bl-full" data-id="element-168"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold-500/10 rounded-tr-full" data-id="element-169"></div>

            <ShieldCheck className="w-16 h-16 text-gold-500 mx-auto mb-6 relative z-10" data-id="element-170" />
            <h3 className="text-2xl font-heading font-bold text-cream-100 mb-6 relative z-10" data-id="element-171">
              GARANTÍA TOTAL 💯
            </h3>
            <p className="text-xl text-cream-200 italic leading-relaxed mb-6 relative z-10" data-id="element-172">
              "Si después de leer el manual completo sientes que no recibiste
              valor real, te devolvemos tu inversión sin preguntas y sin
              burocracia."
            </p>
            <p className="text-gold-400 font-medium relative z-10" data-id="element-173">
              Así de seguros estamos de lo que tienes en tus manos.
            </p>
          </div>
        </FadeIn>

        {/* Urgency */}
        <FadeIn delay={0.3} className="text-center space-y-4 mb-12" data-id="element-174">
          <h3 className="text-xl font-bold text-red-400 uppercase tracking-widest" data-id="element-175">
            Esto no es para siempre
          </h3>
          <p className="text-lg text-cream-200" data-id="element-176">
            Este precio de lanzamiento está disponible por tiempo limitado.
          </p>
          <p className="text-lg text-cream-200" data-id="element-177">Cuando suba el precio, sube.</p>
          <p className="text-lg text-cream-200 italic text-cream-200/80" data-id="element-178">
            No hay cuenta regresiva falsa. No hay urgencia inventada. Solo la
            realidad de que los precios de lanzamiento no duran eternamente.
          </p>
        </FadeIn>

        {/* Final Push */}
        <FadeIn delay={0.4} className="bg-navy-900 p-8 md:p-10 rounded-sm border-t-4 border-gold-500 text-center mb-10" data-id="element-179">
          <h3 className="text-2xl font-heading font-bold text-cream-100 mb-8" data-id="element-180">
            Una última cosa:
          </h3>
          <div className="space-y-4 text-lg text-cream-200 mb-8" data-id="element-181">
            <p data-id="element-182">Cada día que pasa sin dominar esta técnica es un día en que:</p>
            <p className="text-red-300/90" data-id="element-183">
              Un paciente no recibe el mejor tratamiento posible.
            </p>
            <p className="text-red-300/90" data-id="element-184">
              Una oportunidad de diferenciarte pasa de largo.
            </p>
            <p className="text-red-300/90" data-id="element-185">
              Un colega que sí se formó se lleva ese paciente.
            </p>
            <p className="mt-8" data-id="element-186">No porque sea mejor terapeuta que tú.</p>
            <p className="text-xl text-gold-400 font-medium" data-id="element-187">
              Sino porque tiene una herramienta que tú todavía no dominas.
            </p>
          </div>
        </FadeIn>

        {/* Final CTA */}
        <FadeIn delay={0.5} className="text-center" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-cream-100 mb-6" data-id="element-189">
            ¿Listo para cambiar eso?
          </h2>
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-190">
            <span className="text-cream-400/60 text-lg line-through decoration-red-400/70" data-id="element-191">
              $15.99
            </span>
            <span className="text-4xl font-heading font-bold text-cream-100" data-id="element-192">
              $6.39 USD
            </span>
            <span className="bg-red-500 text-white text-sm font-bold py-1 px-3 rounded-sm" data-id="element-193">
              -60%
            </span>
          </div>
          <CTAButton text="QUIERO ACCEDER A KINESIOTAPING CLÍNICO PRO AHORA" isCheckout className="w-full md:w-auto text-xl py-5 px-10" data-id="element-194" />
        </FadeIn>
      </div>
    </section>;
}